import { Alert, Button, Flex, Form, Input } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { apiBasePath, sessionStorageKey_session } from '../../utils/constants';
import { useContext, useState } from 'react';
import { GlobalContext } from '../../utils/globalContext';
import { normalizeMenuProfile } from '../../utils/normalizer';
import { valueToUpperCase, withTrimmedForm } from '../../utils/utils';

const LoginForm = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [alert, setAlert] = useState(null);
  const { setUser, setMenuRoutes } = useContext(GlobalContext);
  const navigate = useNavigate();
  const onFinish = async (values) => {
    setLoader(true);
    try {
      const responseLoginUser = await axios.post(`${apiBasePath}/customer/login`, {
        userName: values.userName,
        authType: 0,
        password: values.userName
      });
      // Set user data in context
      const userData = responseLoginUser.data;
      setUser(userData);
      // Set session in storage
      sessionStorage.setItem(sessionStorageKey_session, JSON.stringify(userData));
      const menuProfile = normalizeMenuProfile({ isAdmin: false });

      setMenuRoutes(menuProfile);
      setLoader(false);
      // Redirect to home or dashboard
      navigate('/');
    } catch (error) {
      setAlert({
        type: 'error',
        message: 'Tuvimos problemas al iniciar tu sesión',
        description: error.status === 403 ? error.response.data.message : 'Por favor, intenta de nuevo'
      });
      setLoader(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
    setLoader(false);
  };

  return (
    <>
      {alert && (
        <Alert
          message={alert.message}
          description={alert.description}
          type={alert.type}
          closable={true}
          banner={true}
          onClose={() => setAlert(null)}
          className="login-alert"
          showIcon
        />
      )}
      <Flex className="login-form-container">
        <img src={`${process.env.PUBLIC_URL}/logoBdi.jpg`} alt="BDI Parking logo" className="login-logo" />
        <Form
          name="login"
          form={form}
          layout="vertical"
          onFinish={withTrimmedForm(onFinish)}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          className="login-form">
          <Form.Item
            label="RFC"
            name="userName"
            onKeyUp={(e) => valueToUpperCase(e.target.value, form, 'userName')}
            rules={[
              {
                required: true,
                message: 'Escriba su RFC'
              }
            ]}>
            <Input />
          </Form.Item>
          <Flex justify="center" vertical className="login-form-buttons">
            <Button type="primary" htmlType="submit" loading={loader}>
              Entrar
            </Button>

            <Button
              color="primary"
              variant="link"
              className="login-register-link"
              onClick={() => navigate('/register')}>
              Registrate aquí
            </Button>
          </Flex>
        </Form>
      </Flex>
    </>
  );
};

export { LoginForm };
